<template>
  <div class="flex h-screen bg-gray-50">
    <!-- 侧边栏 -->
    <div class="bg-white shadow-sm border-r border-gray-200 flex flex-col" style="width: 260px;">
      <!-- Logo区域 -->
      <div class="px-6 py-4 flex items-center">
        <div class="bg-[#FA5050] rounded-md p-1 mr-3">
          <svg class="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"></path>
          </svg>
        </div>
        <h1 class="text-lg font-bold text-primary">青年积分成长系统</h1>
      </div>
      
      <!-- 菜单项 -->
      <nav class="flex-1 overflow-y-auto px-4 pt-2 mt-1">
        <router-link
          v-for="(item, index) in menuItems"
          :key="index"
          :to="item.path"
          class="mt-1 py-3 px-4 flex items-center rounded-lg transition-colors duration-200"
          :class="isActive(item.path) ? 
            'bg-[#FFF8F8] text-[#FA5050]' : 
            'text-gray-700 hover:bg-gray-100'"
        >
          <div class="w-5 h-5 mr-3 flex-shrink-0">
            <svg class="w-full h-full" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" :d="item.icon"></path>
              <path v-if="item.iconSecondary" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" :d="item.iconSecondary"></path>
            </svg>
          </div>
          <span class="font-sm font-bold">{{ item.title }}</span>
        </router-link>
      </nav>
      
      <!-- 用户信息 -->
      <div class="p-2 flex items-center border-t">
        <div class="w-10 h-10 rounded-full bg-[#FFF2F2] flex-shrink-0 mr-3 flex items-center justify-center text-[#FA5050]">
          <span class="text-base font-medium">{{ userInitials }}</span>
        </div>
        <div class="truncate">
          <div class="text-base font-medium text-gray-800">{{ userInfo.name }}</div>
          <div class="text-sm text-gray-500">{{ userInfo.title || '员工' }}</div>
        </div>
      </div>
    </div>

    <!-- 主内容区 -->
    <div class="flex-1 flex flex-col overflow-hidden">
      <!-- 顶部导航栏 -->
      <header class="bg-white shadow-sm">
        <div class="px-6 py-3 flex justify-between items-center">
          <div class="flex items-center relative">
            <input 
              type="text" 
              placeholder="全局搜索" 
              class="pl-8 pr-4 py-2 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-1 focus:ring-[#FA5050] focus:border-[#FA5050] w-64 bg-gray-50"
            >
            <svg class="w-4 h-4 text-gray-400 absolute left-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
            </svg>
          </div>
          <div class="flex items-center space-x-4">
            <!-- 通知铃铛 -->
            <div class="relative">
              <svg class="w-6 h-6 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"></path>
              </svg>
              <span class="absolute top-0 right-0 w-2 h-2 bg-[#FA5050] rounded-full"></span>
            </div>
            <button @click="handleLogout" class="text-sm text-gray-700 hover:text-[#FA5050] px-2">
              员工
            </button>
          </div>
        </div>
      </header>

      <!-- 页面内容 -->
      <main class="flex-1 overflow-x-hidden overflow-y-auto bg-gray-50 px-4 py-3">
        <router-view />
      </main>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Layout',
  data() {
    return {
      userInfo: {
        name: '张三',
        title: '员工',
      },
      menuItems: [
        {
          path: '/dashboard',
          title: '待办任务',
          icon: 'M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6'
        },
        {
          path: '/score/submit',
          title: '积分上报',
          icon: 'M8 7v8a2 2 0 002 2h6M8 7V5a2 2 0 012-2h4.586a1 1 0 01.707.293l4.414 4.414a1 1 0 01.293.707V15a2 2 0 01-2 2h-2M8 7H6a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2v-2'
        },
        {
          path: '/points/review',
          title: '积分审核',
          icon: 'M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4'
        },
        {
          path: '/points/dispute',
          title: '异议处理',
          icon: 'M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z'
        },
        {
          path: '/points/indicators',
          title: '指标管理',
          icon: 'M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4'
        },
        {
          path: '/points/ranking',
          title: '积分排名',
          icon: 'M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z'
        },
        {
          path: '/points/public',
          title: '公示管理',
          icon: 'M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9'
        },
        {
          path: '/points/archives',
          title: '成长档案',
          icon: 'M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z'
        },
        {
          path: '/data-analysis',
          title: '数据分析',
          icon: 'M11 3.055A9.001 9.001 0 1020.945 13H11V3.055z',
          iconSecondary: 'M20.488 9H15V3.512A9.025 9.025 0 0120.488 9z'
        },
        {
          path: '/points/formula',
          title: '公式管理',
          icon: 'M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z'
        },
        {
          path: '/system/user',
          title: '系统管理',
          icon: 'M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z',
          iconSecondary: 'M15 12a3 3 0 11-6 0 3 3 0 016 0z'
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['token', 'user', 'hasPermission']),
    userInitials() {
      if (!this.userInfo.name) return '?'
      return this.userInfo.name.slice(0, 1)
    }
  },
  methods: {
    isActive(path) {
      if (path === '/system/user' && this.$route.path.startsWith('/system')) {
        return true;
      }
      return this.$route.path.startsWith(path)
    },
    handleLogout() {
      this.$store.dispatch('logout')
      this.$router.push('/login')
    }
  },
  created() {
    // 获取用户信息
    if (!this.user) {
      this.$store.dispatch('getUserInfo')
    }
  }
}
</script>

<style scoped>
/* 确保所有链接文字不会被截断 */
a {
  white-space: nowrap;
}

.text-primary {
  color: #FA5050;
}

.bg-primary {
  background-color: #FA5050;
}

:focus {
  outline: none;
}
</style>
